<!-- Modo panel flotante: overlay y panel con posición fija (cuando no está dentro de ion-menu) -->
<ng-container *ngIf="!dentroDeMenu">
  <div class="formulario-overlay" *ngIf="visible">
    <div class="formulario-overlay-backdrop" (click)="cerrar()" (touchend)="onOverlayTouchend($event)" role="button"
      tabindex="-1" aria-label="Cerrar panel"></div>
    <div class="formulario-overlay-cutout" aria-hidden="true"></div>
  </div>
  <div class="formulario-panel" [class.visible]="visible">
    <ng-container *ngTemplateOutlet="contenidoFormulario"></ng-container>
  </div>
</ng-container>

<!-- Modo dentro de ion-menu: solo el contenido (el menú aporta animación y backdrop) -->
<div class="formulario-contenido-menu" *ngIf="dentroDeMenu">
  <ng-container *ngTemplateOutlet="contenidoFormulario"></ng-container>
</div>

<ng-template #contenidoFormulario>
  <div class="formulario-header">
    <h2>{{ getTitulo() }}</h2>
    <p class="subtitulo">{{ getSubtitulo() }}</p>
    <ion-button fill="clear" size="small" class="btn-cerrar" (click)="cerrar()">
      <ion-icon slot="icon-only" name="close-outline"></ion-icon>
    </ion-button>
  </div>

  <div class="formulario-content">
    <form [formGroup]="formulario" class="formulario-asesoria">
      <!-- Unidad Operativa -->
      <ion-item class="form-item" lines="none">
        <ion-label position="stacked">Unidad Operativa <span class="required">*</span></ion-label>
        <ion-select formControlName="id_unidad_operativa" placeholder="Seleccione una unidad operativa"
          interface="popover" [interfaceOptions]="{ cssClass: 'select-popover select-popover-wide unidad-operativa-popover' }">
          <ion-select-option *ngFor="let u of unidadesOperativas" [value]="u.id">
            {{ u.nombre }}
          </ion-select-option>
        </ion-select>
      </ion-item>

      <!-- Categoría + Asesor -->
      <div class="fila-dos-columnas">
        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Categoría <span class="required">*</span></ion-label>
          <ion-select formControlName="categoria" placeholder="Seleccione categoría" interface="popover"
            [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
            <ion-select-option value="">Seleccione categoría</ion-select-option>
            <ion-select-option *ngFor="let c of categoriasAsesoriaOpciones" [value]="c.value">
              {{ c.label }}
            </ion-select-option>
          </ion-select>
        </ion-item>

        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">
            Asesor Especialista
            <span class="required" *ngIf="requiereAsesorEspecialista()">*</span>
          </ion-label>
          <ion-input formControlName="asesor_especialista" placeholder="Ej: Juan Pérez"></ion-input>
        </ion-item>
      </div>

      <!-- Nombre -->
      <ion-item class="form-item" lines="none">
        <ion-label position="stacked">Nombre de la Actividad <span class="required">*</span></ion-label>
        <ion-input formControlName="nombre_asesoria" placeholder="Ej: Taller de Riego Tecnificado"></ion-input>
      </ion-item>

      <!-- Temas (mismo listado de objetivos de visitas) -->
      <div class="form-item form-item-objetivos" style="margin-bottom: 0;">
        <ion-item lines="none" style="--padding-start: 0; --inner-padding-end: 0;">
          <ion-label position="stacked">Temas <span class="required">*</span></ion-label>
          <ion-select formControlName="id_objetivo_visita" placeholder="Seleccione temas" interface="popover"
            multiple="true" [interfaceOptions]="{ cssClass: 'select-popover select-popover-medium' }">
            <ion-select-option *ngFor="let obj of objetivosVisita" [value]="obj.id_objetivo_visita">
              {{ obj.descripcion }}
            </ion-select-option>
          </ion-select>
        </ion-item>
        
        <ion-item lines="none" *ngIf="formulario.get('id_objetivo_visita')?.value?.includes(13)" style="--padding-start: 0; --inner-padding-end: 0;">
          <ion-label position="stacked">Describa otro <span class="required">*</span></ion-label>
          <ion-input formControlName="objetivo_otro" placeholder="Describa el tema"></ion-input>
        </ion-item>
      </div>

      <!-- Objetivos -->
      <ion-item class="form-item" lines="none">
        <ion-label position="stacked">Objetivos <span class="required">*</span></ion-label>
        <ion-textarea formControlName="objetivos" placeholder="Describa los objetivos de la actividad" rows="3"></ion-textarea>
      </ion-item>

      <!-- Lugar -->
      <ion-item class="form-item" lines="none">
        <ion-label position="stacked">
          Lugar
          <span class="required" *ngIf="formulario.get('notificar_ejecutivos')?.value">*</span>
        </ion-label>
        <ion-input formControlName="lugar" placeholder="Ej: Sede comunitaria El Manzano"></ion-input>
      </ion-item>

      <!-- Fecha Inicio + Fecha Término -->
      <div class="fila-dos-columnas">
        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Fecha Inicio <span class="required">*</span></ion-label>
          <ion-datetime-button datetime="datetime-asesoria-fecha-inicio"></ion-datetime-button>
          <ion-popover [keepContentsMounted]="true">
            <ng-template>
              <ion-datetime id="datetime-asesoria-fecha-inicio" [value]="fechaInicioISO || undefined" [min]="getFechaMinimaSeleccionISO()"
                (ionChange)="onFechaInicioChange($event)" locale="es-CL" presentation="date"
                [formatOptions]="{ date: { day: '2-digit', month: '2-digit', year: 'numeric' } }">
              </ion-datetime>
            </ng-template>
          </ion-popover>
        </ion-item>

        <ion-item class="form-item" lines="none">
          <ion-label position="stacked">Fecha Término <span class="required">*</span></ion-label>
          <ion-datetime-button datetime="datetime-asesoria-fecha"></ion-datetime-button>
          <ion-popover [keepContentsMounted]="true">
            <ng-template>
              <ion-datetime id="datetime-asesoria-fecha" [value]="fechaISO || undefined" [min]="fechaInicioISO || getFechaMinimaSeleccionISO()"
                (ionChange)="onFechaChange($event)" locale="es-CL" presentation="date"
                [formatOptions]="{ date: { day: '2-digit', month: '2-digit', year: 'numeric' } }">
              </ion-datetime>
            </ng-template>
          </ion-popover>
        </ion-item>
      </div>

      <!-- Hora Programada -->
      <ion-item class="form-item form-item-hora-programada" lines="none">
        <ion-label position="stacked">
          Hora Programada
          <span class="opcional-texto" *ngIf="!formulario.get('notificar_ejecutivos')?.value"> (Opcional)</span>
          <span class="required" *ngIf="formulario.get('notificar_ejecutivos')?.value"> *</span>
        </ion-label>
        <div class="hora-input-container" style="display: flex; align-items: center; gap: 8px; margin-top: 8px;">
          <button type="button" class="fake-datetime-button" id="trigger-hora-programada">
            {{ formatearHoraParaMostrar(horaProgramadaHHmm) }}
          </button>
          
          <ion-button fill="clear" color="danger" *ngIf="horaProgramadaHHmm" (click)="limpiarHoraProgramada()" style="margin: 0; --padding-start: 4px; --padding-end: 4px;">
            <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
          </ion-button>
        </div>
        <ion-popover trigger="trigger-hora-programada" [keepContentsMounted]="true">
          <ng-template>
            <ion-datetime [value]="horaProgramadaHHmm || undefined" (ionChange)="onHoraProgramadaChange($event)"
              locale="en-US" presentation="time"
              [formatOptions]="{ time: { hour: '2-digit', minute: '2-digit', hour12: true } }">
            </ion-datetime>
          </ng-template>
        </ion-popover>
      </ion-item>

      <!-- Checkbox Notificar -->
      <ion-item class="form-item-checkbox" lines="none" style="margin-top: 10px; --background: transparent;">
        <ion-checkbox formControlName="notificar_ejecutivos" labelPlacement="end">
          Notificar por correo a Ejecutivos/as
        </ion-checkbox>
      </ion-item>
    </form>
  </div>

  <div class="formulario-footer">
    <ion-button fill="outline" (click)="cerrar()">
      Cancelar
    </ion-button>
    <ion-button (click)="onGuardarClick()" [disabled]="guardando || !esFormularioValido()">
      <ion-icon slot="start" name="paper-plane-outline"></ion-icon>
      Guardar Actividad
    </ion-button>
  </div>
</ng-template>
